"use strict";

export function initInScope ($scope) {
let $flugblattHotspot = $scope.find('.js-flugblatt-hotspot');
    $flugblattHotspot.each((index, base) => {

        let $flugblattHotspotItem = $(base).find('.js-flugblatt-hotspot__item');
        $flugblattHotspotItem.each((index, element) => {

            let coords = $(element).data('coords'),
                hotspotImg =  $(base).find('img'),
                hotspotImgWidth = hotspotImg.width(),
                hotspotImgHeight = hotspotImg.height(),
                hotspotOverlay = $(base).find('.js-flugblatt-hotspot__overlay'),

                topLeftX = 0,
                topLeftY = 0,
                bottomRightX = 0,
                bottomRightY = 0,
                // Calculate the pixels of the percentage
                coordsHeight = (hotspotImgHeight/100) * coords['height'],
                coordsWidth = (hotspotImgWidth/100) * coords['width'];

            Object.keys(coords).map(function(key, index) {

                topLeftX = (hotspotImgWidth/100) * coords['left'];
                topLeftY = (hotspotImgHeight/100) * coords['top'];

                bottomRightX = (hotspotImgWidth/100) * (coords['left']) + coordsWidth;
                bottomRightY = (hotspotImgHeight/100) * (coords['top']) + coordsHeight;

            });

            let coordsValue = topLeftX + ',' + topLeftY + ',' + bottomRightX + ',' + bottomRightY;
            $(element).attr('coords', coordsValue);

            // Add icon to hotspot
            let coordsImg = $(element).attr('coords').split(',').map(function(value) { return parseInt(value, 10); }),
                $icon = $(`<div class="flugblatt-hotspot__icon"><img class="flugblatt-hotspot__icon-img" src="/static/icons/svg/plus.svg" alt="link"></div>`),
                centerX = (coordsImg[0] + coordsImg[2]) / 2,
                centerY = (coordsImg[1] + coordsImg[3]) / 2;

            $icon.css({
                'left': centerX + 'px',
                'top': centerY + 'px'
            });
            $(base).append($icon);

            // Add overlay hover to hotspot
            let timeoutId;
            $(element).on('mouseover', function() {
                timeoutId = setTimeout(function() {
                    hotspotOverlay.css({
                        'left': topLeftX + 'px',
                        'top': topLeftY + 'px',
                        'width': coordsWidth + 'px',
                        'height': coordsHeight + 'px'
                    }).addClass('visible');
                    $icon.addClass('hover');
                }, 150);
            }).on('mouseout', function() {
                hotspotOverlay.removeClass('visible');
                $icon.removeClass('hover');
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            });

        });
});
}